export default __webpack_public_path__ + "static/media/Asset 9.a6996b1f.png";